import './Affliate.css';
import React, { useState } from 'react';
// import './Dashboard.css';
import { Box, Grid2 } from '@mui/material';
import Header from '../Header/Header';
import Pagination from '@mui/material/Pagination';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';




import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ToastContainer } from "react-toastify";


const drawerWidth = 260;
const AffliateView = () => {
    const [setOpen] = React.useState(false);


    const theme = useTheme();
    const lg = useMediaQuery(theme.breakpoints.up('lg'));




    const [limit] = useState(10);
    const [page, setPage] = useState(1);
    const [totalPage] = useState(0);

    const location = useLocation();

    console.log(location?.state, "location");

    const affliateUser = location?.state?.value?.referedUserDetails;

    const array = ["S.no", "Name", "Email"];


    return (
        <div className="UserWithdrawHistry">
            <ToastContainer />
            <Box sx={{ display: lg ? 'flex' : 'block' }}>
                <Header />
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}>
                     <h2 style={{ color:"#fff", margin:"0px" }}>Afflicate View</h2>
                    <Grid2 container spacing={2}>

                        <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <div className="custom_table">
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                {array.map((val, index) =>
                                                    <TableCell align="center" key={index}>
                                                        {val}
                                                    </TableCell>)}

                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {affliateUser.
                                                slice((page - 1) * limit, page * limit).
                                                map((value, index) =>
                                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell align='center' component="th" scope="row">
                                                            {limit * (page - 1) + index + 1}
                                                        </TableCell>
                                                        <TableCell align="center">{value?.name || '-'}</TableCell>
                                                        <TableCell align="center">{value?.email || '-'}</TableCell>
                                                    </TableRow>)}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Pagination
                                    className="pagnation"
                                    count={totalPage}
                                    page={page}
                                    onChange={(event, value) => {
                                        setPage(value);
                                    }}
                                    shape="rounded" />

                            </div>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </div>);

};

export default AffliateView;